// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"EditCategory_categoriesContainer__BVSzS","done":"EditCategory_done__B4mY9"};